import type { IconList } from '@snowit/icetypes';

import PartnerGlobalPicker from '@snowit/components/Pickers/PartnerGlobalPicker';
import useBreakpoints from '@snowit/hooks/useBreakpoints';
import useStyle from '@snowit/system/useStyle';
import { ButtonIcon } from '@snowit/ui';

import Logo from '../Logo';
import TenantGlobalPicker from '../Pickers/TenantGlobalPicker';
import ToggleColorMode from './ToggleColorMode';
import UserMenu from './UserMenu';

import cx from 'classnames';
import s from './Header.module.scss';

type HeaderProps = { className?: string; sidebarOnClick?: () => void };

const Header = (props: HeaderProps) => {
  const { className, sidebarOnClick } = props;
  const { logo } = useStyle();
  const { minWidth } = useBreakpoints();

  const renderPickers = () => {
    if (!minWidth.md) return null;
    return (
      <div className={s.wrapPicker}>
        <TenantGlobalPicker />
        <PartnerGlobalPicker small />
      </div>
    );
  };

  return (
    <header className={cx(s.header, className)}>
      <ButtonIcon
        classNames={{ button: s.sidebarBtn }}
        icon={'sidebar'}
        onClick={sidebarOnClick}
        theme={'transparent'}
        size={'db'}
        color={'text'}
      />
      <Logo className={s.logo} name={logo as IconList} maxHeight={1.75} />
      {renderPickers()}
      <ToggleColorMode />
      <UserMenu />
    </header>
  );
};

export default Header;
